export const PAYMENT_POLL_FIRST_PHASE_MS = 2 * 60 * 1000;
export const PAYMENT_POLL_MAX_MS = 6 * 60 * 1000;
export const PAYMENT_POLL_FAST_INTERVAL_MS = 3000;
export const PAYMENT_POLL_SLOW_INTERVAL_MS = 10000;

export function getPaymentPollInterval(startedAt: number | null, now = Date.now()) {
  if (!startedAt) return false;

  const elapsed = now - startedAt;
  if (elapsed >= PAYMENT_POLL_MAX_MS) return false;
  if (elapsed < PAYMENT_POLL_FIRST_PHASE_MS) return PAYMENT_POLL_FAST_INTERVAL_MS;
  return PAYMENT_POLL_SLOW_INTERVAL_MS;
}
